enum CleaningStatus {
  TO_DO = 'TO_CLEAN',
  IN_PROGRESS = 'IN_PROGRESS',
  CLEANED = 'CLEANED',
  PROHIBITED = 'PROHIBITED',
}

export default CleaningStatus;

export const CLEANING_FILTER_STATUSES = [CleaningStatus.TO_DO, CleaningStatus.IN_PROGRESS];